/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksGetSecret } from "../../funcs/webhooksGetSecret.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetWebhookSecretRequest$inboundSchema,
};

export const tool$webhooksGetSecret: ToolDefinition<typeof args> = {
  name: "webhooks-get-secret",
  description: `Get the secret key for verifying webhook payloads.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksGetSecret(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
